export default __webpack_public_path__ + "static/media/137.b4c3a102.webp";